module.exports = __webpack_public_path__ + "static/media/vi-bear.29909c82.svg";